import {
  type IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import ErrorContext from '~/context/common/ErrorContext';
import { logError } from '~/utilities/loggers';

type ErrorMessage<T> = IncomingMessage<
  T,
  {
    errorMessage: string;
  }
>;

function isErrorMessage<T>(
  message: IncomingMessage<T, any>
): message is ErrorMessage<T> {
  return (
    message.event === ListenerEvent.Error &&
    message.payload.errorMessage != null
  );
}

export default function useErrorHandler<T>(): MessageHandler<T> {
  const { setNativeError } = useContext(ErrorContext);

  return useMemo(
    () =>
      new MessageHandler(isErrorMessage, (message: ErrorMessage<T>) => {
        const { errorMessage, ...context } = message.payload;
        const err = new Error(errorMessage);

        setNativeError(err);
        logError(err, { location: 'Native', ...context });
      }),
    [setNativeError]
  );
}
